<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-01-17 11:00 -->
<!-- Description:  -->
<template>
  <form @submit.prevent="save()">
    <div class="mb-3">
      <label for="">Nivel</label>
      <select name="" id="" class="custom-select" v-model="dataForm.level">
        <option value="U">Usuario</option>
        <option value="E">Entidad</option>
        <option value="S">Sistema</option>
      </select>
    </div>
    <div class="mb-3">
      <label for="">Clave</label>
      <input class="form-control" type="" v-model="dataForm.key">
    </div>
    <div class="mb-3">
      <label for="">Tipo de Dato</label>
      <select name="" id="" class="custom-select" v-model="dataForm.data_type">
        <option value=""></option>
        <option value="string"> string </option>
        <option value="int"> int </option>
        <option value="float"> float </option>
        <option value="boolean"> boolean </option>
      </select>
    </div>
    <div class="mb-3">
      <label for="">Valor</label>
      <input class="form-control" type="" v-model="dataForm.value">
    </div>
    <button class="btn btn-primary" :disabled="sending">Guardar</button>
  </form>
</template>
<script>
import {AdminService} from "../AdminService.js";

const rules = {}
export default {
  name: "SettingForm",
  components: {
    //
  },

  // directives

  props: {
    disabled: {default: false},
  },

  data: () => ({
    sending: false,
    dataForm: {},
  }),

  computed: {
    errors() {return false;}
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    async save() {
      this.sending = true; 
      let bodyContent = {};
      if(this.dataForm.level == 'U') {
        bodyContent.user_id = this.$store.state.user.id;
      } else if (this.dataForm.level == 'E') {
        bodyContent.entity_id = this.$store.state.user.entity_id;
      }
      let res = await AdminService.saveSetting({
        ...this.dataForm,
        ...bodyContent,
      });
      this.$emit("saved", res);
      this.sending = false; 
    },
    reset() {
      this.sending = false;
      this.dataForm = {};
    },
    setValue(reg) {
      this.dataForm = reg;
    },
  }
};
</script>
<style scoped></style>
